import { Module, MutationTree, GetterTree } from "vuex";
import { AutomaticReport } from "@/models";

export interface AutomaticReportsCacheState {
  slug: string | null;
  automaticReports: AutomaticReport[];
}

export const state: AutomaticReportsCacheState = {
  slug: null,
  automaticReports: [],
};

export const getters: GetterTree<AutomaticReportsCacheState, unknown> = {
  cachedAutomaticReports:
    (state) =>
    (slug: string): AutomaticReport[] | null =>
      state.slug === slug ? state.automaticReports : null,
};

export const mutations: MutationTree<AutomaticReportsCacheState> = {
  setCachedAutomaticReports(
    state,
    payload: { slug: string; automaticReports: AutomaticReport[] }
  ) {
    state.slug = payload.slug;
    state.automaticReports = payload.automaticReports;
  },

  invalidateAutomaticReportsCache(state) {
    state.slug = null;
    state.automaticReports = [];
  },
};

export const automaticReportsCache: Module<
  AutomaticReportsCacheState,
  unknown
> = {
  namespaced: true,
  state,
  getters,
  mutations,
};
